import { render, staticRenderFns } from "./remark-hinit.vue?vue&type=template&id=6b27290b&scoped=true&"
import script from "./remark-hinit.vue?vue&type=script&lang=js&"
export * from "./remark-hinit.vue?vue&type=script&lang=js&"
import style0 from "./remark-hinit.vue?vue&type=style&index=0&id=6b27290b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b27290b",
  null
  
)

export default component.exports